import { render, staticRenderFns } from "./JobBurnUp.vue?vue&type=template&id=cc537c96&scoped=true&"
import script from "./JobBurnUp.vue?vue&type=script&lang=js&"
export * from "./JobBurnUp.vue?vue&type=script&lang=js&"
import style0 from "./JobBurnUp.vue?vue&type=style&index=0&id=cc537c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc537c96",
  null
  
)

export default component.exports